/**
 * 정정 요청 페이지 공용 컴포넌트 — Defense.js 에서 분리.
 *   header / urgencyBanner / FAQ·faqSection / reportTable.
 *
 * 클로저 상태(S)·헬퍼(getDeadlineRemaining)를 팩토리 인자로 주입받아,
 * 함수 본문은 Defense.js 원본과 동일하게 유지(들여쓰기·HTML 출력까지 바이트 보존).
 */
import Util from '../../../Common/Util';

export function makeComponents(S, getDeadlineRemaining) {

        function header(title, showX) {
            // (피드백) 페이지 닫기(X) 버튼 제거 — showX 무관하게 항상 미표시.
            return `<div class="hdr">
              <div style="width:32px"></div>
              <span class="hdr-t">${title}</span>
              <div style="width:32px"></div>
            </div>`;
        }

        function urgencyBanner() {
            // (피드백) 제출 후 화면(접수완료·반려·처리완료·만료·철회)에선 "요청 기한까지 …남음" 카운트다운 미표시.
            const POST_SUBMIT = ['registered', 'recalled', 'notme_done', 'notme_approved', 'notme_rejected'];
            if (POST_SUBMIT.includes(S.scr)) return '';
            const rem = (S.scr === 'registered') ? { expired: true } : getDeadlineRemaining();
            let inner;
            if (rem.expired) {
                inner = `<div style="background:var(--sf2);border:1px solid var(--bdr);color:var(--t2);padding:12px 16px;border-radius:12px;text-align:center">
                  <p style="font-size:11px;font-weight:600">장비대금 체불 제보 소명·정정</p>
                  <p style="font-size:15px;font-weight:800;margin-top:4px;letter-spacing:-.3px;color:var(--t1)">소명·정정 기한 만료</p>
                </div>`;
            } else {
                // 긴급/일반은 색상(빨강 vs 핑크)이 아니라 같은 포인트의 농도로 가른다.
                // 팔레트에 빨강이 따로 없고, 색만으로 나누면 다크모드에서 둘 다 깨진다.
                const isUrgent = rem.days === 0;
                const bg     = isUrgent ? 'var(--Rg)' : 'var(--Rl)';
                const bd     = isUrgent ? 'var(--R)'  : 'var(--Rg)';
                inner = `<div style="background:${bg};border:1px solid ${bd};padding:12px 16px;border-radius:12px;text-align:center">
                  <p style="font-size:11px;font-weight:600;letter-spacing:-.2px;color:var(--t2)">장비대금 체불 제보 소명·정정</p>
                  <p style="margin-top:4px;letter-spacing:-.3px;line-height:1.15">
                    <span style="font-size:14px;font-weight:500;color:var(--t2)">소명·정정 기한까지</span>
                    <span style="font-size:17px;font-weight:800;margin:0 4px;color:var(--R)">${rem.days}일 ${String(rem.hours).padStart(2, '0')}시간 ${String(rem.mins).padStart(2, '0')}분</span>
                    <span style="font-size:14px;font-weight:500;color:var(--t2)">남음</span>
                  </p>
                </div>`;
            }
            return `<div class="urgency-banner" style="padding:12px 16px 16px">${inner}</div>`;
        }

        // 자주 묻는 질문 (rAuthFirst/rAuthReturn 에서 사용)
        // 기획 확정 2026-10-02 — 소명(제보자와 통화, 기록 없음) / 정정(본인 아님 요청, 관리자 검토) 두 갈래
        const FAQ = [
            { q: '왜 제가 이 문자를 받았나요?', a: '회원이 귀하의 연락처를 장비대금 미지급 건으로 제보했습니다. 사실과 다르거나 지급·합의로 해결하시려면 [제보자와 통화](소명), 본인(귀사)이 아니거나 명의가 잘못 등록됐으면 [정정 요청하기]로 바로잡아 달라고 요청하실 수 있습니다.' },
            { q: '소명과 정정은 뭐가 다른가요?', a: '소명은 제보 내용이 사실과 다르거나 지급·합의로 풀고 싶을 때 제보자와 직접 통화하는 것입니다. 이 페이지에 따로 기록되지 않으며, 합의되면 제보자가 고객센터에 철회를 요청합니다. 정정은 본인(귀사)이 아닐 때(번호 승계·타인) 증빙 서류와 함께 등록 전에 바로잡아 달라고 요청하는 것으로, 관리자가 검토합니다.' },
            { q: '소명·정정을 하지 않으면 어떻게 되나요?', a: '요청 기한 내에 소명·정정이 없으면 체불업체(자)로 정식 등록되어 악덕알리미 회원들에게 공유됩니다.' },
            { q: '제보자와 직접 통화하고 싶어요', a: '[제보자와 통화] 버튼으로 안심번호를 통해 연결됩니다. 제보자의 실제 연락처는 노출되지 않습니다. 휴대폰 본인 인증을 마친 뒤 연결됩니다.' },
            { q: '재접속은 어떻게 하나요?', a: '문자로 받은 링크를 다시 누르시면 휴대폰 본인 인증 후 진행 상황을 확인할 수 있습니다. 한 번 인증하면 30분간 재인증 없이 이용 가능합니다.' },
            { q: '제출 후 수정할 수 있나요?', a: '제출 후에는 수정이 불가합니다. 서류가 부족해 반려되면 담당자가 전화로 안내드립니다.' },
        ];

        function faqSection(defaultOpen) {
            return `<div style="padding:16px">
              <details class="faq-section"${defaultOpen ? ' open' : ''} style="background:var(--sf);border-radius:14px;border:1px solid var(--bdr);overflow:hidden">
                <summary style="cursor:pointer;list-style:none;display:flex;justify-content:space-between;align-items:center;min-height:56px;padding:12px 16px;font-size:15px;font-weight:800;color:var(--t1);letter-spacing:-.3px">
                  자주 묻는 질문
                  <svg class="faq-section-chv" width="14" height="14" viewBox="0 0 14 14" fill="none" style="transition:transform .25s"><path d="M3 5l4 4 4-4" stroke="var(--t2)" stroke-width="2" stroke-linecap="round"/></svg>
                </summary>
                <div>
                ${FAQ.map(f => `<details class="faq-item" style="border-top:1px solid var(--bdr)">
                  <summary style="cursor:pointer;display:flex;justify-content:space-between;align-items:center;list-style:none;min-height:52px;padding:12px 16px;font-size:13px;font-weight:600;color:var(--t1);transition:background .2s">
                    <span style="display:flex;align-items:center;gap:8px;text-align:left"><span style="color:var(--R);font-weight:800;flex-shrink:0">Q</span>${f.q}</span>
                    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" style="transition:transform .2s;flex-shrink:0"><path d="M3 5l4 4 4-4" stroke="var(--t2)" stroke-width="1.8" stroke-linecap="round"/></svg>
                  </summary>
                  <p style="font-size:12px;color:var(--t2);line-height:1.7;padding:12px 16px 16px;background:var(--sf2);margin:0">${f.a}</p>
                </details>`).join('')}
                </div>
              </details>
            </div>`;
        }

        // 등록내역 표. 제보자 증빙 사진은 행 자체가 없다 — 서버가 인증 뒤에도 URL·장수를 안 준다(번호 승계자 열람 방지).
        function reportTable() {
            const r = S.report;
            const startDate = (r.workDate || '').split('~')[0].trim();
            return `<div class="tbl">
              <div style="background:var(--sf2);padding:8px 16px;font-size:11px;color:var(--t2);font-weight:700;letter-spacing:-.2px">업체(자)명</div>
              <div class="tbl-row" style="border-top:1px solid var(--bdr)">
                <div style="flex:1;padding:14px;font-size:14px;color:var(--t1);background:var(--sf);font-weight:600">${Util.escapeHtml(r.co)}</div>
              </div>
              <div style="background:var(--sf2);padding:8px 16px;font-size:11px;color:var(--t2);font-weight:700;letter-spacing:-.2px;border-top:1px solid var(--bdr)">제보 내용</div>
              <div class="tbl-row" style="border-top:1px solid var(--bdr)"><div class="tbl-tit">제보자</div><div class="tbl-val">${Util.escapeHtml(r.rep)}</div></div>
              <div class="tbl-row"><div class="tbl-tit">작업일자</div><div class="tbl-val">${Util.escapeHtml(startDate)}</div></div>
              <div class="tbl-row"><div class="tbl-tit">주소</div><div class="tbl-val">${Util.escapeHtml(r.location)}</div></div>
              <div class="tbl-row"><div class="tbl-tit">장비업종</div><div class="tbl-val">${Util.escapeHtml(r.equipment || '-')}</div></div>
            </div>`;
        }

    return { header, urgencyBanner, faqSection, reportTable };
}
